import React, { Component } from "react";
import { Form, Icon, Input } from "antd";
import Button from "../Button/index";
import Wrapper from "../LandingBlockWrapper/BlockWrapper";
import authActions from "../../actions/auth";
import { injectIntl } from "react-intl";
import history from "../../history";
import Flexbox from "flexbox-react";
import messages from "./messages";

const FormItem = Form.Item;


class PasswordReset extends Component{
	
	handleResetPassword = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				authActions.sendPasswordResetEmail(values);
				history.push("/login");
			}
		});
	};
	
	render() {
		const { form: { getFieldDecorator }, intl: { formatMessage } } = this.props;
		return (
			<Flexbox
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				className="Wrapper"
			>
				<h1>Reset your password</h1>
				<div className="form">
					<h3>Enter your email address and we will send you a link to reset your password</h3>
					<Form className="login-form">
						<FormItem>
							{getFieldDecorator("email", {
								rules: [
									{
										type: "email",
										required: true,
										message: formatMessage(messages.emailInValid)
									},
									{
										message: formatMessage(messages.email)
									}
								]
							})(
								<Input
									prefix={<Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }}/>}
									placeholder={formatMessage(messages.placeholder)}/>
							)}
						</FormItem>
					</Form>
					<Flexbox>
						<Button
							type="primary"
							onClick={this.handleResetPassword}
						>
							Send password reset email
						</Button>
					</Flexbox>
				</div>
			</Flexbox>
		);
	}
}

const PasswordResetPage = Form.create()(injectIntl(PasswordReset));

export default () => {
	return <Wrapper className="PasswordReset">
		<PasswordResetPage/>
	</Wrapper>;
};









// WEBPACK FOOTER //
// ./src/components/PasswordReset/PasswordReset.js